import RedesignDescriptor from './vending-redesign-descriptor';
import AramarkDescriptor from './vending-aramark-descriptor';
import CompanyKitchenDescriptor from './vending-companykitchen-descriptor';
import RefiveDescriptor from './vending-refive-descriptor';
import Settings from 'src/Settings';
import {StyleProp, ViewStyle, TextStyle} from 'react-native';
import {BuildTypeEnum} from '../../../../constants/BuildTypeEnum';

const typeDescriber = {
  [BuildTypeEnum.aramark]: AramarkDescriptor,
  [BuildTypeEnum.canteen]: RedesignDescriptor,
  [BuildTypeEnum.default]: RedesignDescriptor,
  [BuildTypeEnum.companykitchen]: CompanyKitchenDescriptor,
  [BuildTypeEnum.refive]: RefiveDescriptor,
};

export function getDescriber() {
  return typeDescriber[Settings.buildType as keyof typeof typeDescriber];
}

export interface VendingStylesDescriptor {
  balance: StyleProp<TextStyle>;
  balanceLabel: StyleProp<TextStyle>;
  timer: StyleProp<TextStyle>;
  timerLabel: StyleProp<TextStyle>;
  locationName: StyleProp<TextStyle>;
  messageText: StyleProp<TextStyle>;
  progressContainer: StyleProp<ViewStyle>;
  messageContainer: StyleProp<ViewStyle>;
}
